import { FC, useMemo, } from "react";
// 组件
import SuperTable from '../SuperTable';
// 方法
import classNames from "classnames";
import { setMergeColumns } from "./utils";
// 常量
import { MergeTableProps } from "./interface";
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
import './style.less';

/** 合并（行/列）表格 */
const MergeTable: FC<MergeTableProps> = props => {
  const {
    columns: outColumns, childrenDataKey, mainRowKey, pagination, defaultShowLength, subTotalKeys, subTotalText,
    emptyChildren, childrenRowKey, size, wrapperClassName, bordered, childrenTableMinHeight, ...restProps
  } = props;
  /** 列配置 */
  const columns = useMemo(() => {
    return setMergeColumns(
      outColumns,
      childrenDataKey,
      {
        defaultShowLength,
        subTotalKeys,
        subTotalText,
        emptyChildren,
        childrenRowKey,
        size,
        bordered,
        childrenTableMinHeight,
      });
  }, [outColumns, childrenDataKey, defaultShowLength, subTotalKeys, subTotalText, emptyChildren, childrenRowKey, size, bordered, childrenTableMinHeight,]);
  /** 分页配置 */
  const currentPagination = useMemo(() => {
    if (pagination === false) return false;
    return {
      pageSizeOptions: ['5', '10', '20', '50'],
      pageSize: 10,
      ...pagination,
    };
  }, [pagination]);

  return (
    <SuperTable
      {...restProps}
      bordered={bordered}
      size={size}
      rowKey={mainRowKey}
      isMergeTable={true}
      defaultUnrepeated={false}
      columns={columns}
      chilrenKey={childrenDataKey}
      pagination={currentPagination}
      wrapperClassName={classNames("merge-table", wrapperClassName)}
    />
  );
};

MergeTable.defaultProps = {
  bordered: true,
  emptyChildren: TABLE_COLUMN_EMPTY,
};

export default MergeTable;
